var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('overlay',{attrs:{"show":_vm.mutableShow,"click":_vm.close}}),_vm._v(" "),_c('transition',{attrs:{"name":"popwindow-modal"}},[(_vm.mutableShow)?_c('div',{staticClass:"popwindow-modal"},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-715c64d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/popwindow/index.vue
// module id = null
// module chunks = 